import {
  Switch as MuiSwitch,
  FormControlLabel,
  FormControlLabelProps,
} from "@mui/material";
import { forwardRef } from "react";

interface SwitchProps extends Omit<FormControlLabelProps, "control"> {
  switchProps?: React.ComponentProps<typeof MuiSwitch>;
}

const Switch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => {
  const { label, switchProps, sx, ...rest } = props;

  return (
    <FormControlLabel
      control={<MuiSwitch ref={ref} {...switchProps} />}
      label={label}
      sx={{ marginY: "0.4rem", ...sx } as any}
      {...rest}
    />
  );
});

Switch.displayName = "Switch";

export default Switch;
